import Icon from "@ant-design/icons";
import { forwardRef, type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import SVG from "images/Notifications.svg?react";

import "./BTIconNotifications.less";

import { type IBTIconProps } from "../BTIcon.types";
import { useBaseIcon } from "../BTIcon.utilities";

interface IBTIconNotificationsProps extends IBTIconProps {
    isOnWhite?: boolean;
    ref?: React.Ref<HTMLSpanElement>;
}

export const BTIconNotifications: FunctionComponent<IBTIconNotificationsProps> = forwardRef(
    (baseProps, ref) => {
        const { isOnWhite, ...iconProps } = baseProps;
        const [props] = useBaseIcon(iconProps);

        return (
            // eslint-disable-next-line react/forbid-elements
            <Icon
                ref={ref}
                {...props}
                component={SVG}
                className={cn("BTIconNotifications", props.className, {
                    isOnWhite,
                    isOnDark: !isOnWhite,
                })}
            />
        );
    },
);
